import { Autocomplete, Backdrop, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import ByProdId from "./byProdId";
import { CSVLink } from "react-csv";

const OutletUnsavedReport = () => {
    const classes = useStyle()
    const dispatch = useDispatch();
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(100);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);

    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [data, setData] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const [catData,setCatData] = useState([])
    const [subData,setSubData] = useState([])
    const [activeStep , setActiveStep] = useState("0")
    const [rowData , setRowData] = useState(null)
    const outletName = localStorage.getItem('outlet_name')
    const [allSubData, setAllSubData] = useState([]);

    const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().startOf('month').format(),
    toDate :  moment().format()
  })
  const [options, setOptions] = useState({
    customer : null,
    category : null,
    subCategory : null
})
const onEdit = (e) => {
  console.log(e.row)
  setActiveStep("1")
  setRowData(e.row)
}
function handleOptions(value, name){
    console.log(name, value)
    // setOptions(prev=>({...prev,[name] : value}))
    setOptions((prev) => ({ ...prev, [name]: value }));
        if (name === "category") {
          setOptions((prev) => ({ ...prev, subCategory: null }));
          filterSubCategories(value ? value.id : null);
        }
}
function filterSubCategories(categoryId) {
  if (categoryId) {
    const filteredSubData = allSubData.filter(
      (sub) => sub.category_id === categoryId
    );
    setSubData(filteredSubData);
  } else {
    setSubData([]);
  }
}
const columns = [
  {
    field : 'id',
    headerName : 'S.no',
    minWidth : 70,
    maxWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "otName",
    headerName: "Outlet Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "code",
    headerName: "Code",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "item",
    headerName: "category_name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "barcode_count",
    headerName: "Barcode Count",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
]
console.log(options.customer != null ? options.customer.fullname : outletName)
const rows = _.map(data,(val,idx)=>({
  // id: val.prodid,
  id: idx + 1,  
  code : val.code,
  item : val.category_name,
  barcode_count : val.barcode_count,
  // amt : parseFloat(val.amount).toFixed(0),
  otName: val.fullname
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag,
  
}
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.barcode_count);
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
      })
      .catch((err) => {
        setData([]);
        setRowData(null);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getCategory(){
    axios.get('/v1/categories')
    .then(res=>{
        // _.filter(res.data, val=>{
        //     if(val.is_active){
        //          setCatData(res.data)
        //     }
        // })
        const activeCats = res.data.filter(val => val.is_active);
setCatData(activeCats);

    })
    .catch(err=>{
      setData([]);
      setRowData(null);
        console.log(err)
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}

function getSubCategory(){
    axios.get('/v1/subcategories')
    .then(res=>{
            // setSubData(res.data)
            setAllSubData(res.data);
    })
    .catch(err=>{
        console.log(err)
        setData([]);
        setRowData(null);
        dispatch(setSnackbar(true,'error',err.response.data.error))
    })
}

function handleOutletSalesItemWise() {
  // reset immediately so your table shows “no rows” until new data arrives
  setData([]);
  setRowData(null);
  // const postData = {
  //   from_date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
  //   to_date: moment(dateLimit.toDate).format("YYYY-MM-DD"),
  //   customer: options.customer?.id || 0,
  //   category: options.category?.id || 0,
  //   subcategory: options.subCategory?.id || 0,
  // };
const outletlist = options.customer?.id || 0
const url = outletlist && outletlist !== 0
  ? `v1/reports/closing/stock/outlet/unsaved/${outletlist}`
  : `v1/reports/closing/stock/outlet/unsaved/`;
  axios.get(url)
    .then(res => {
      setData(res.data);
      console.log(res.data,"res.dataresponse");
      
      setPageCount(res.data.length);
    })
    .catch(err => {
      setData([]);
      setRowData(null);
 
      
      // setDateLimit({fromDate:"",toDate:""})

      dispatch(setSnackbar(
        true,
        "error",
        err.response?.data?.errors?.[0]?.message || "Something went wrong"
      ));
    });
}

  useEffect(() => {
    getSupplierData();
    // getCategory()
    // getSubCategory()
  }, []);
  
  useEffect(() => {
    if (dateLimit.fromDate && dateLimit.toDate) {
      handleOutletSalesItemWise();
    }
  }, [
    page,
    rowsPerPage,
    dateLimit.fromDate,
    dateLimit.toDate,
    options.customer,
    options.category,
    options.subCategory,
  ]);
  
  console.log(rows,"datadata");

  
  return (
  <Fragment>
    <Helmet><title>Closing Stock Unsaved Reports</title></Helmet>
   <Typography variant="h6">Closing Stock Unsaved Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[{id:0 , fullname :"All"} , ...supplier]}
            onChange={(e,value)=>handleOptions(value,'customer')}
            getOptionLabel={option=>option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>

      </Grid>
      {/* {activeStep === "0" ?  */}
       <CustomTable props={props}/> 

  </Fragment>
  )
}

export default memo(OutletUnsavedReport)